export class UploadValidationError extends Error {
  constructor(message, errorType) {
    super(message);
    this.errorType = errorType;
  }
}